###
  Показывает подсказки
###

class INTENT.utils.Tooltip

  options =
    trigger: "hover"
    html: true

  @init: (target) ->
    if target?
      $(target).tooltip options
    else
      $("[data-toggle=tooltip]").tooltip options

  @destroy: (target) ->
    $(target).tooltip 'destroy'

$ ->
  INTENT.utils.Tooltip.init()